export default "__VITE_ASSET__DSAsYHPM__"